import { Icon } from '@types-custom/models/ui/icon-model';
import { Observable } from 'rxjs';

export interface IModalAforoModel {
  icon: Icon;
  alt: string;
  id: string;
  address: string;
  title: string;
  avgSpeed: number;
  flowCount: number;
  lightVehicles: number;
  heavyVehicles: number;
  largeHeavyVehicles: number;
  trucks: number;
  buses: number;
  bikes: number;
  vehicleCount?: number;
  motorcycleCount?: number;
  pedestrianCount?: number;
  nId: string;
  aforoDataSource?: AbstractAforoSensorDataSource;
}

export abstract class AbstractAforoSensorDataSource {

  abstract getImageModal(id: any): Observable<any>;
  /**
 * @returns all sensors (cameras) locations with their corresponding data fo avg speed and count, also the flow per each vehicle type
 */
  abstract getLayerAforoGeoJson(): Observable<any>;

  /**
   *
   * @returns all sensors (cameras) data, avg speed and count, also the address and time
   */
  abstract getPanelAforoMeasurements(): Observable<any>;

  /**
   * @param sensorId
   * @returns for an specific sensor (camera) the data of avg speed and count for each vehicle type
   */
  abstract getModalAforoMeasurements(sensorId: string): Observable<any>;
}

export enum vehicleTypeEnum {
  BUS = 'Buses',
  TRUCK = 'Camiones',
  VANS = 'Vans',
  CAR = 'Carros',
  MOTORBIKE = 'Motocicletas',
  SCOOTER = 'Scooter',
  BICYCLES = 'Bicicletas',
  MALE = 'male',
  FEMALE = 'female',
  ADULT = 'adult',
  KID = 'kid',
  UNKNOWN = 'unknown',
}

export interface IOptionTypeVehicle {
  type: vehicleTypeEnum;
  icon: Icon;
  alt: string;
  active: boolean;
  value: number;
  tooltip: string;
}
